<template>
  <div>
    <v-card>
      <div>
        <v-row class="px-3 align-center">
          <v-col cols="12" md="4" sm="4" lg="3">
            <UpdateCategory category="isCreate" @refreshList="refreshList" />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" sm="4" lg="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="isLoading"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id="{ item }">
          <v-btn class="text-lowercase" @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>

        <template v-slot:item.description="{ item }">
          <div class="d-flex align-end">
            <div
              v-if="$vuetify.breakpoint.xs && item.description.length <= 50"
              class="text-wrap"
            >
              <span
                v-html="
                  item.description ? item.description : $t('noDescription')
                "
                :class="item.description ? '' : 'grey--text'"
              ></span>
            </div>
            <div
              v-else-if="!$vuetify.breakpoint.xs"
              :class="
                showMore == item.id ? 'text-wrap' : 'text-wrap handleText'
              "
            >
              <v-tooltip top v-if="item.description.length > 50">
                <template v-slot:activator="{ on, attrs }">
                  <div style="max-width: 130px" class="">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      v-html="item.description"
                    ></span>
                  </div>
                </template>
                <span v-html="item.description"></span>
              </v-tooltip>
              <span
                v-else
                v-html="
                  item.description ? item.description : $t('noDescription')
                "
                :class="item.description ? '' : 'grey--text'"
              ></span>
            </div>
          </div>
          <!-- description mobile data-table -->
          <v-dialog
            v-if="$vuetify.breakpoint.xs && item.description.length > 50"
            v-model="showDescriptionDialog[item.id]"
            :key="item.id"
            :retain-focus="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                text
                color="info"
                small
                v-on="on"
                @click.prevent="$set(showDescriptionDialog, item.id, true)"
              >
                {{ $t("view") }}
              </v-btn>
            </template>
            <v-toolbar dense>
              <v-toolbar-title>
                {{ $t("description") }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                @click.prevent="$set(showDescriptionDialog, item.id, false)"
              >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-toolbar>
            <v-card class="pa-6">
              {{ item.description }}
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.live="{ item }">
          <div>
            {{ typeUI(item.live) }}
          </div>
        </template>

        <template v-slot:item.standard="{ item }">
          <div>
            {{ standardUI(item.standard) }}
          </div>
        </template>

        <template v-slot:item.status="{ item }">
          <div>
            <v-icon :color="handleColorStatus(item.status)" x-small left>
              mdi-circle
            </v-icon>
            {{ statusUI(item.status) }}
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn-toggle>
            <UpdateCategory :category="item" @refreshList="refreshList" />
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import UpdateCategory from "./updateCategory.vue";
export default {
  name: "list-categories-config",
  components: {
    UpdateCategory,
  },
  data: () => ({
    search: "",
    isLoading: false,
    items: [],
    select: "",
    createCategory: true,
    showDescriptionDialog: {},
    showMore: "",
  }),

  computed: {
    headers() {
      const headers = [
        {
          text: "ID",
          value: "id",
          align: "no-wrap",
          width: "10%",
        },
        {
          text: this.$t("name"),
          value: "name",
          align: "flex-wrap",
          width: "200px",
        },
        {
          text: this.$t("weight"),
          value: "weight_order",
          align: "no-wrap",
          width: "10%",
        },
        {
          text: this.$t("description"),
          value: "description",
          align: "no-wrap",
          // width: "20%"
        },
        {
          text: "Lobby",
          value: "live",
          align: "no-wrap",
          width: "10%",
        },
        {
          text: this.$t("category"),
          value: "standard",
          align: "no-wrap",
          width: "10%",
        },
        {
          text: "Status",
          value: "status",
          align: "no-wrap",
          width: "10%",
        },
      ];

      if (this.$permission("113")) {
        headers.push({
          text: this.$t("actions"),
          value: "actions",
          align: "no-wrap",
          width: "10%",
        });
      }

      return headers;
    },

    casinoLobby() {
      return this.$store.state.filters.selectCasinoLobby.value;
    },

    categories() {
      return this.$store.state.filters.autocompleteCasinoCategories;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  mounted() {
    this.listCategories();
  },

  watch: {
    saveFilters(val) {
      val && this.listCategories();
    },
  },

  methods: {
    listCategories() {
      const body = {
        live: this.casinoLobby, // 0 cassino normal, 1 cassino ao vivo, "" Todos
      };
      this.$axios
        .post(
          "colab/cassino/GamesAgregation/ListCategories",
          this.$formdata(body)
        )
        .then((response) => {
          this.items = response.data.dados;
          this.items.sort((a, b) => b.weight_order - a.weight_order);
        })
        .catch((error) => {
          console.log(error);
          this.items = [];
        })
        .finally(() => (this.isLoading = false));
    },

    statusUI(value) {
      const obj = {
        0: `${this.$t("inativa")}`,
        1: `${this.$t("ativa")}`,
      };
      return obj[value];
    },

    standardUI(value) {
      const obj = {
        0: this.$t("customCategory"),
        1: this.$t("verticalCategory"),
      };
      return obj[value];
    },

    typeUI(value) {
      const obj = {
        0: this.$t("casino"),
        1: this.$t("liveCasino"),
      };
      return obj[value];
    },

    handleColorStatus(status) {
      if (status == 0) return "grey";
      if (status == 1) return "green";
    },

    refreshList() {
      this.listCategories();
    },
  },
};
</script>

<style scoped>
.read-more {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: none !important;
}
.handleText {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.v-tooltip__content {
  font-size: 14px !important;
  max-width: 256px !important;
  opacity: 1 !important;
  padding: 16px 16px;
  overflow-wrap: break-word;
}
</style>
